import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ConsultationDataService} from './impl/service/ngrx/consultationData.service';
import {ConsultationRepository} from './impl/service/ngrx/consultation.repository';
import {errorMessages} from '../../../core/error/errorMessages';

@NgModule({
})
export class ConsultationConsultationModule {

    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: ConsultationDataService,
                repository: ConsultationRepository,
    ) {

        entityDataService.registerServices({
            Consultation: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Consultation: repository,
        });

        errorMessages.set('MEDICAL_CONSULTATION_AGENDA_EVENT_SAVED_PARTNER_CHANGED',
            'Le patient d\'un rendez-vous médical ne peut être changé');
        errorMessages.set('MEDICAL_CONSULTATION_AGENDA_EVENT_SAVED_PARTNER_UNDEFINED',
            'Veuillez sélectionner un patient');
        errorMessages.set('MEDICAL_CONSULTATION_AGENDA_EVENT_SAVED_PARTNER_IS_NOT_A_PATIENT',
            'La personne sélectionnée n\'est pas un patient');


    }
}
